import { useTranslate } from "@refinedev/core";
import { Popconfirm, Radio } from "antd";
import { RadioChangeEvent, RadioGroupProps } from "antd/es/radio";

export enum ApplySettings {
  ALL = "all",
  SPECIFIC = "specific",
  NONE = "none",
}

export const ApplySettingsRadioGroup = ({
  value,
  onChange,
  ...props
}: RadioGroupProps) => {
  const t = useTranslate();
  return (
    <Radio.Group
      style={{ display: "flex", flexDirection: "column", gap: 10 }}
      value={value}
      {...props}
    >
      <Popconfirm
        title={t("components.templates.TemplatesBoard.confirmTitle")}
        onConfirm={() => {
          onChange?.({
            target: { value: ApplySettings.ALL },
          } as RadioChangeEvent);
        }}
      >
        <Radio value={ApplySettings.ALL}>
          {t("components.templates.settings.applySettings.title", {
            type: t("components.templates.settings.applySettings.types.all"),
          })}
        </Radio>
      </Popconfirm>
      <Radio
        value={ApplySettings.SPECIFIC}
        onClick={() => {
          onChange?.({
            target: { value: ApplySettings.SPECIFIC },
          } as RadioChangeEvent);
        }}
      >
        {t("components.templates.settings.applySettings.title", {
          type: t("components.templates.settings.applySettings.types.specific"),
        })}
      </Radio>
    </Radio.Group>
  );
};
